import { styled } from '@mui/material';

export const Grid = styled('div')`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  gap: 20px;
  padding: ${({ theme }) => theme.spacing(0.5)};
`;
